import React, { useState } from "react";
import { useAuth } from "@/auth/AuthContext";
import { ArrowRight } from "lucide-react";
import Logo from "@/components/Logo";
import InstallAppButton from "@/components/InstallAppButton";

export default function Login() {
  const { login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await login(email, password);
    setLoading(false);
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      {/* Left visual */}
      <div className="hidden md:flex relative overflow-hidden" style={{ background: "#242321" }}>
        <div className="absolute inset-0 opacity-40" style={{
          backgroundImage: `url(https://images.unsplash.com/photo-1636986056375-184676d8ca14?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200)`,
          backgroundSize: "cover", backgroundPosition: "center"
        }} />
        <div className="relative z-10 flex flex-col justify-between p-12 text-[#E8E6E1] w-full">
          <Logo light size={38} />
          <div>
            <h1 className="font-display text-4xl leading-tight mb-3">Every conversation.<br/>Every stitch. Tracked.</h1>
            <p className="text-[#C6C2BB] max-w-md leading-relaxed">From lead to dispatch — a single relay that never drops the baton. Built for the way Marsh Clothing actually works.</p>
          </div>
          <div className="label-tiny text-[#A3A09A]">Internal Operations · v1</div>
        </div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center p-8 bg-[#FDFBF7]">
        <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="login-form">
          <div className="md:hidden mb-8"><Logo size={32} /></div>
          <h2 className="font-display text-2xl mb-1">Sign in</h2>
          <p className="text-sm text-[#757169] mb-8">Enter your role credentials to continue.</p>

          <div className="mb-4">
            <div className="label-tiny mb-1.5">Email</div>
            <input data-testid="login-email" type="email" className="input-field" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@marshclothing.com" autoComplete="email" required />
          </div>
          <div className="mb-6">
            <div className="label-tiny mb-1.5">Password</div>
            <input data-testid="login-password" type="password" className="input-field" value={password} onChange={e=>setPassword(e.target.value)} required />
          </div>

          {error && <div className="mb-4 p-3 rounded-md bg-[#F7DFDF] text-[#7C2626] text-sm" data-testid="login-error">{error}</div>}

          <button data-testid="login-submit" type="submit" className="btn-primary w-full flex items-center justify-center gap-2" disabled={loading}>
            {loading ? "Signing in..." : (<>Sign in <ArrowRight size={16} /></>)}
          </button>

          <div className="mt-8 pt-6 border-t border-[#EAE5DB] text-center space-y-3">
            <InstallAppButton variant="ghost" className="mx-auto" />
            <a href="/portal/login" className="block text-xs text-[#757169] hover:text-[#C45A41]">Are you a customer? → Client portal</a>
          </div>
        </form>
      </div>
    </div>
  );
}
